var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      style: _vm.style,
      on: {
        dragenter: _vm.dragenter,
        dragleave: _vm.dragleave,
        dragover: _vm.dragover,
        drop: _vm.drop
      }
    },
    [
      _c("div", { staticClass: "d-flex flex-column h-100" }, [
        _c("div", { staticStyle: { flex: "1 1 auto" } }),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { flex: "0 0 auto", "text-align": "center" } },
          [
            _c("i", { staticClass: "fas fa-cloud-upload-alt" }),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("txtDropFileHere")) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticStyle: { flex: "1 1 auto" } })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }